import { ensureJourneyDb, getById, insertRow, updateRow, writeAudit } from "../../db";
import { createThread } from "../../db/schema";
import { assertThreadAccess, assertTransactionAccess, resolveActor } from "./access";
import { badRequest, conflict, notFound } from "./errors";
import { hydrateThread } from "./helpers";

/** POST /api/threads/create */
export function postThreadsCreate(body = {}, session) {
  ensureJourneyDb();
  const actor = resolveActor(session);
  const transaction = getById("transactions", body.transaction_id);
  if (!transaction) throw notFound("Transaction not found");
  assertTransactionAccess(actor, transaction);
  if (transaction.status !== "open") throw conflict("Cannot add a thread to a closed transaction");
  if (actor.journeyRole === "buyer" || actor.journeyRole === "seller") {
    throw badRequest("Clients cannot create new threads");
  }

  const thread = insertRow(
    "message_threads",
    createThread({
      transaction_id: transaction.id,
      created_by_user_id: body.created_by_user_id || actor.userId,
      status: "active",
    })
  );
  writeAudit({
    user_id: actor.userId,
    action_type: "thread.create",
    transaction_id: transaction.id,
    metadata: { thread_id: thread.id },
  });
  return hydrateThread(thread);
}

/** POST /api/threads/archive */
export function postThreadsArchive(body = {}, session) {
  ensureJourneyDb();
  const actor = resolveActor(session);
  const thread = getById("message_threads", body.thread_id);
  if (!thread) throw notFound("Thread not found");
  assertThreadAccess(actor, thread);
  if (actor.journeyRole === "buyer" || actor.journeyRole === "seller") {
    throw badRequest("Clients cannot archive threads");
  }

  const next =
    thread.status === "archived"
      ? thread
      : updateRow("message_threads", thread.id, { status: "archived" });

  writeAudit({
    user_id: actor.userId,
    action_type: "thread.archive",
    transaction_id: thread.transaction_id,
    metadata: { thread_id: thread.id, idempotent: thread.status === "archived" },
  });
  return hydrateThread(next);
}
